// @flow
import JQueryView, { on } from '../common/JQueryView';
import { numberToCurrency } from '../../utils/commonUtils';

export default class FormView extends JQueryView {
  stockPrice: number;
  minInvestmentAmount: number;
  investmentUnit: number;

  constructor(
    stockPrice: number,
    minInvestmentAmount: number,
    investmentUnit: number,
    amount: number,
  ) {
    super('form');
    this.stockPrice = stockPrice;
    this.minInvestmentAmount = minInvestmentAmount;
    this.investmentUnit = investmentUnit;

    amount =
      amount == null || amount === 0
        ? $('#plus_projects_order_form_amount').val()
        : amount;
    this.updateTotalPrice(amount);
  }

  @on('input #plus_projects_order_form_amount')
  onChangeAmount(event: any) {
    const amount = event.currentTarget.value;
    this.updateTotalPrice(amount);
    this.validation(this.minInvestmentAmount, this.investmentUnit, amount);
  }

  updateTotalPrice(amount: number) {
    amount = parseInt(amount, 10);

    if (isNaN(amount) || amount < 1) {
      return $('#total_price').text('');
    }

    var totalPrice = this.stockPrice * amount;

    $('#total_price').text(numberToCurrency(totalPrice));
  }

  validation(
    minInvestmentAmount: number,
    investmentUnit: number,
    amount: number,
  ) {
    let $error = $('#min-amount-error');
    if (isNaN(amount)) {
      $error.text('');
      return;
    }

    if (amount < minInvestmentAmount || amount % investmentUnit !== 0) {
      $error.text('※入力内容に誤りがあります。正しい数量を入力してください。');
    } else {
      $error.text('');
    }
  }
}
